import { combineReducers } from '@reduxjs/toolkit';
import productSlice from './product/productSlice';
import categorySlice from './category/categorySlice';
import crossReferenceSlice from './crossreference/crossreferenceSlice';
import technicalInfoSlice from './technicalinfo/technicalinfoSlice';

const catalogSlice = combineReducers({
    product: productSlice,
    category: categorySlice,
    crossReference: crossReferenceSlice,
    technicalInfo: technicalInfoSlice,
});

export default catalogSlice;
